const noAnalyticsDataCondition = (element: HTMLElement) => {
  return (
    element &&
    element.dataset &&
    typeof element.dataset.analyticsLabel === 'undefined' &&
    typeof element.dataset.analyticsService === 'undefined' &&
    typeof element.dataset.analyticsComponent === 'undefined'
  );
};

export default noAnalyticsDataCondition;
